import { Record } from 'immutable';
import {
  SET_ERROR_MESSAGE,
  REQUEST_ERROR,
  CLEAR_ERROR,
  SET_REDIRECTION,
  CLEAR_REDIRECTION,
  BAD_ROUTE,
  REQUEST_CITIES,
  RECEIVE_CITIES,
  REQUEST_SHOP,
  RECEIVE_SHOP,
  REQUEST_BARBER,
  REQUEST_BARBERS,
  RECEIVE_BARBER,
  RECEIVE_BARBERS,
  REQUEST_SERVICE,
  REQUEST_SERVICES,
  RECEIVE_SERVICE,
  RECEIVE_SERVICES,
  TIME_UNAVAILABLE,
  FAILED_CHARGES,
  SET_APPLE_PAY,
  MAINTENANCE_MODE,
  THIRD_PARTY_PROMO,
} from './constants';

const DEFAULT_CONFIRM_TEXT = 'Back to home';
const BAD_TIME_CONFIRM_TEXT = 'Choose another time';
const FAILED_CHARGES_CONFIRM_TEXT = 'Close';

const InitialState = Record({
  error_message: null,
  redirect_to: null,
  isFetching: false,
  confirmButtonText: DEFAULT_CONFIRM_TEXT,
  applePay: false,
  thirdPartyPromotion: {},
});

const initialState = new InitialState();

export default function appReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_CITIES:
    case REQUEST_SHOP:
    case REQUEST_BARBER:
    case REQUEST_BARBERS:
    case REQUEST_SERVICE:
    case REQUEST_SERVICES:
      return state.set('isFetching', true);

    case RECEIVE_CITIES:
    case RECEIVE_SHOP:
    case RECEIVE_BARBER:
    case RECEIVE_BARBERS:
    case RECEIVE_SERVICE:
    case RECEIVE_SERVICES:
      return state.set('isFetching', false);

    case MAINTENANCE_MODE:
      return state.set('error_message', action.payload).set('confirmButtonText', 'OK');

    case SET_ERROR_MESSAGE:
      return state.set('error_message', action.error.message);

    case CLEAR_ERROR:
      return state.set('error_message', null);

    case SET_REDIRECTION:
      return state.set('redirect_to', action.payload);

    case REQUEST_ERROR:
      return state.set('error_message', action.payload).set('redirect_to', '/');

    case BAD_ROUTE:
      return state.withMutations(s =>
        s.set('isFetching', false).set('redirect_to', action.payload)
      );

    case CLEAR_REDIRECTION:
      return state.set('redirect_to', null);

    case TIME_UNAVAILABLE:
      return state.withMutations(s =>
        s.set('error_message', action.payload.message)
          .set('redirect_to', action.payload.redirect)
          .set('confirmButtonText', BAD_TIME_CONFIRM_TEXT)
      );

    case FAILED_CHARGES:
      return state.withMutations(s =>
        s.set('error_message', action.payload)
          .set('confirmButtonText', FAILED_CHARGES_CONFIRM_TEXT)
      );

    case SET_APPLE_PAY:
      return state.set('applePay', action.payload);

    case THIRD_PARTY_PROMO:
      return state.setIn(['thirdPartyPromotion'], action.payload);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/reducer.js